import { CultureInfo } from '../culture-info.model';
import { CultureInfoVai } from './vai';

/**
 * @ignore
 */
export const CultureInfoVaiLatn: CultureInfo = {
  name: 'vai-Latn',
  displayName: 'Vai',
  iso3LanguageCode: 'vai',
  iso2LanguageCode: 'vai',
  ietfLanguageTag: 'vai-Latn',
  parent: CultureInfoVai
};
